module.exports = __webpack_public_path__ + "assets/img/grid_silver.a723d952.png";